'use strict';

var Data = require("../data.js");
var Util = require("../layouts/util.js");
var $$Array = require("bs-platform/lib/js/array.js");
var React = require("react");
var Gatsby = require("../gatsby.js");
var Partners = require("../partners.js");
var Navigation = require("../components/navigation.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var SpeakerCard = require("../components/speakerCard.js");
var ParallaxScroll = require("../components/ParallaxScroll.js");
var LogoSvg = require("../assets/logo.svg");

var component = ReasonReact.statelessComponent("Home");

function speakerColumn(speaker) {
  return React.createElement("li", {
              key: speaker[/* name */0],
              className: "speaker-list--item"
            }, ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/speakers/#" + Data.Speaker[/* speakerAnchor */1](speaker), /* None */0, /* None */0, /* None */0, /* array */[ReasonReact.element(/* None */0, /* None */0, SpeakerCard.make(speaker, /* None */0, /* array */[]))])));
}

function sponsorLogo(sponsor) {
  console.log(sponsor);
  var match = sponsor[/* tier */3];
  var className;
  switch (match) {
    case 0 : 
        className = "partners--listItem_gold";
        break;
    case 1 : 
        className = "partners--listItem_catering";
        break;
    case 2 : 
        className = "partners--listItem_local";
        break;
    case 3 : 
        className = "partners--listItem_partner";
        break;
    
  }
  var match$1 = sponsor[/* tier */3];
  var title;
  switch (match$1) {
    case 0 : 
        title = "Gold Sponsor";
        break;
    case 1 : 
        title = "Food & Drinks";
        break;
    case 2 : 
        title = "Supporter";
        break;
    case 3 : 
        title = "Partner";
        break;
    
  }
  return React.createElement("li", {
              key: sponsor[/* name */0],
              className: "partners--listItem " + className
            }, React.createElement("figure", {
                  className: "partners--figure"
                }, React.createElement("a", {
                      title: sponsor[/* name */0],
                      href: sponsor[/* href */2],
                      target: "_blank"
                    }, React.createElement("img", {
                          className: "partners--logo",
                          alt: sponsor[/* name */0],
                          src: sponsor[/* logoUrl */1]
                        })), React.createElement("figcaption", {
                      className: "partners--caption"
                    }, Util.s(title))));
}

function make() {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              return React.createElement("div", undefined, ReasonReact.element(/* None */0, /* None */0, ParallaxScroll.make("top-bottom", "bottom-top", {
                                  "--header-ty": {
                                    from: "100px",
                                    to: "-100px"
                                  },
                                  "--header-clip": {
                                    from: "10",
                                    to: "4vw"
                                  }
                                }, React.createElement("header", {
                                      className: "teaser"
                                    }, React.createElement("section", {
                                          className: "container_centered grid grid_6cols"
                                        }, React.createElement("h1", {
                                              className: "teaser--logo"
                                            }, React.createElement("img", {
                                                  className: "teaser--image",
                                                  alt: "ReasonConf 2018",
                                                  src: LogoSvg
                                                })), React.createElement("section", {
                                              className: "teaser--navigation"
                                            }, ReasonReact.element(/* None */0, /* None */0, Navigation.make("/", /* None */0, /* array */[]))), React.createElement("div", {
                                              className: "teaser--meta"
                                            }, React.createElement("h2", {
                                                  className: "teaser--dates"
                                                }, React.createElement("time", {
                                                      dateTime: "2018-05-11/2018-05-13"
                                                    }, Util.s("11–13 May 2018"))), React.createElement("p", {
                                                  className: "teaser--location"
                                                }, Util.s("Vienna, Austria"))), React.createElement("p", {
                                              className: "teaser--tagline"
                                            }, Util.s("World’s first Reason conference for web-developers & OCaml enthusiasts")))))), React.createElement("section", {
                              className: "offering"
                            }, React.createElement("div", {
                                  className: "container_centered grid grid_6cols"
                                }, React.createElement("h2", {
                                      className: "offering--heading"
                                    }, Util.s("Get productive with Reason in 3 days")), React.createElement("section", {
                                      className: "offering--text"
                                    }, React.createElement("p", undefined, Util.s("\n                  Reason is the next big thing and it is time to bring\n                  the community together. Come and learn about the\n                  language and get inspired for innovation.\n                ")), React.createElement("p", undefined, Util.s("\n                  We want to motivate you to add Reason & OCaml to\n                  your professional toolbelt and make you\n                  feel comfortable in the ecosystem.\n                ")), React.createElement("p", undefined, Util.s("\n                  This conference is aiming for a well-balanced schedule\n                  with a practical, social and theoretical context.\n                "))), React.createElement("dl", {
                                      className: "timeline"
                                    }, React.createElement("dt", {
                                          className: "timeline--date"
                                        }, React.createElement("time", {
                                              dateTime: "2018-05-11"
                                            }, Util.s("11"), React.createElement("sup", undefined, Util.s("th")), Util.s(" May, Friday"))), React.createElement("dd", {
                                          className: "timeline--content"
                                        }, React.createElement("h3", undefined, Util.s("Day 1: Get started")), React.createElement("p", undefined, Util.s("\n                    An optional workshop day to get every beginner and\n                    intermediate attendee into the language &\n                    platform.\n                  "))), React.createElement("dt", {
                                          className: "timeline--date"
                                        }, React.createElement("time", {
                                              dateTime: "2018-05-12"
                                            }, Util.s("12"), React.createElement("sup", undefined, Util.s("th")), Util.s(" May, Saturday"))), React.createElement("dd", {
                                          className: "timeline--content"
                                        }, React.createElement("h3", undefined, Util.s("Day 2: Get inspired")), React.createElement("p", undefined, Util.s("\n                    This is the main conference day with lectures and talks.\n                    Speakers of the Reason / OCaml community (with special guests\n                    from the Reason & ReasonReact project) will inspire attendees for\n                    more advanced topics.\n                  "))), React.createElement("dt", {
                                          className: "timeline--date"
                                        }, React.createElement("time", {
                                              dateTime: "2018-05-13"
                                            }, Util.s("13"), React.createElement("sup", undefined, Util.s("th")), Util.s(" May, Sunday"))), React.createElement("dd", {
                                          className: "timeline--content"
                                        }, React.createElement("h3", undefined, Util.s("Day 3: Get productive")), React.createElement("p", undefined, Util.s("\n                    On the last day we encourage attendees to start\n                    their first Reason projects, aided by our mentors,\n                    speakers and volunteers. Alternatively for those\n                    who want to relax, we offer a local-guided tour\n                    through the beautiful city Vienna!\n                  ")))))), React.createElement("section", {
                              className: "speakers"
                            }, React.createElement("div", {
                                  className: "container_centered"
                                }, React.createElement("h2", undefined, Util.s("Speakers")), ReasonReact.element(/* None */0, /* None */0, ParallaxScroll.make("top-bottom", "bottom-top", {
                                          "--speakers-ty": {
                                            from: "100px",
                                            to: "-100px"
                                          }
                                        }, React.createElement("ul", {
                                              className: "speaker-list"
                                            }, $$Array.map(speakerColumn, Data.Speaker[/* speakers */19])))))), React.createElement("section", {
                              className: "sponsors"
                            }, React.createElement("div", {
                                  className: "container_centered"
                                }, React.createElement("h2", undefined, Util.s("Sponsors & Partners")), React.createElement("p", {
                                      className: "extraText"
                                    }, Util.s("Do you want to help us make a better conference? "), ReasonReact.element(/* None */0, /* None */0, Gatsby.Link[/* make */0]("/sponsors", /* None */0, /* None */0, /* None */0, /* array */[Util.s("Become a sponsor!")]))), React.createElement("ul", {
                                      className: "partners"
                                    }, $$Array.map(sponsorLogo, Partners.sponsors)), React.createElement("ul", {
                                      className: "partners"
                                    }, $$Array.map(sponsorLogo, Partners.partners)))));
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

var $$default = ReasonReact.wrapReasonForJs(component, (function () {
        return make(/* array */[]);
      }));

var Tickets = 0;

var Link = 0;

exports.component = component;
exports.Tickets = Tickets;
exports.Link = Link;
exports.speakerColumn = speakerColumn;
exports.sponsorLogo = sponsorLogo;
exports.make = make;
exports.$$default = $$default;
exports.default = $$default;
exports.__esModule = true;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/pages/pageIndex.js